import React, { FC } from "react";
import { Row } from "react-bootstrap";
import { Network } from "../../../models/types";
import { VariationViewItemProps } from "../../../models/common";
import { NetworkItem } from "../../variationItems/NetworkItem";
import "../views.scss";

export const Networks: FC<VariationViewItemProps> = ({ revision }) => {
    const useAnalytics = revision.buildData?.analytics ?? false;

    const items = revision?.buildData?.networks.map((object: Network) => (
        <NetworkItem
            key={object.id}
            network={object}
            revision={revision}
            useAnalytics={useAnalytics}
        />
    ));
    return <Row className="justify-content-start ms-auto">{items}</Row>;
};
